var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-avatar',{staticClass:"d-inline-block mx-2",staticStyle:{"margin-top":"-2px"},attrs:{"color":"grey lighten-1","size":"6"}})
}
var staticRenderFns = []

export { render, staticRenderFns }